
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_b_11401_87406)"}},[_c('circle',{attrs:{"cx":"10.002","cy":"10.595","r":"10","fill":"#FFA901","fill-opacity":".1"}})]),_c('path',{attrs:{"d":"M8.224 8.635L9.577 5.91a.474.474 0 01.85 0l1.353 2.725 3.025.44a.47.47 0 01.261.802l-2.188 2.12.517 2.995a.473.473 0 01-.688.496l-2.705-1.415-2.706 1.415a.473.473 0 01-.687-.496l.517-2.995-2.189-2.12a.47.47 0 01.262-.802l3.025-.44z","fill":"#FFA901"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_b_11401_87406","x":"-11.998","y":"-11.405","width":"44","height":"44","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"BackgroundImageFix","stdDeviation":"6"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur_11401_87406"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_backgroundBlur_11401_87406","result":"shape"}})])])])
          )
        }
      }
    